<div #closeDiv class="add-payment scrollbar-custom">
  <div class="ui-g-12 p-zero dialog-header">
    <div class="send-dialog-heading">
      <span *ngIf="!isProcessing">{{'global-payment.enter-your-card-information'|translate}}</span>
      <span *ngIf="isProcessing">Please wait
        <i class="fal fa-spinner rotate"></i>
      </span>
    </div>
    <i disabled="isSubmitting" class="fal fa-times fa-sm dialog-close"
      (click)="isSubmitting ? null : closePaymentModal(false, {})"></i>
  </div>
  <!-- body -->
  <div class="dialog-body">
    <!-- customer details -->
    <div class="ui-g-12 mb-2 payment-date customer-details-font d-flex align-items-center">
      <div class="col-md-1 d-md-block d-none">
        <span style="font-size: 29px">
          <i class="fal fa-file-invoice"></i>
        </span>
      </div>

      <div class="col-md-11">
        <table class="table shopData" style="margin-bottom: 0rem">
          <tbody>
            <tr>
              <td>{{'global-payment.customer'|translate}}:</td>
              <td>
                <strong>{{ payment?.customer?.fullName || payment?.customer?.displayName }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{'global-payment.ro-invoice'|translate}}:</td>
              <td>
                <strong>{{ payment?.code }} {{ payment?.estimate?.invCode ? '/ ' + payment?.estimate?.invCode :
                  payment?.invCode ? '/ ' + payment?.invCode : '' }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ (isRefund ? 'refund' : 'payment')|translate }} {{'amount'|translate}}:</td>
              <td class="font-600 font-14" style="color: var(--primary-500)">
                {{ isCountryCanada ? 'CAD' : 'USD' }}
                <span *ngIf="isRefund">(${{ usdPayment }})</span>
                <span *ngIf="!isRefund"> ${{ usdPayment }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- payment details -->
    <div class="ui-g-12 payment-date" style="color: #252828;">

      <div class="flex-start-center">
        <div class="ui-g-7">
          <strong>{{'global-payment.card-details'|translate}}</strong>
        </div>
        <div class="ui-g-5 p-0">
          <img src="../../../../../assets/img/gp-payment-method.svg" alt="" class="d-block ml-auto img-fluid" />
        </div>
      </div>

      <div class="ui-g-12 globalPayment-error" *ngIf="globalPaymentErrorMsg">
        <p>
          <i class="fal fa-info-circle text-dark pr-2"></i>
          <span>{{ globalPaymentErrorMsg }}</span>
        </p>
      </div>

      <div class="globalPayment-payment-form container-form">
        <div *ngIf="isProcessing" class="overlay-form flex-center-center w-100">
          <!-- Please wait fields are loading ...... -->
          <i class="fal fa-spinner rotate font-50"></i>
        </div>
        <div class="content-form">
          <div class="row pr-1">
            <div class="col-md-3">
              <div class="row">
                <div class="col-2 col-md-3 text-center">
                  <i class="far fa-stream"></i>
                </div>
                <div class="col-10 col-md-9 p-0">
                  <label for="name" class="font-13 mb-0">{{'global-payment.name-on-card'|translate}}</label>
                  <app-input style="display: block" class="card-zip-field" id="name-on-card"
                    placeholder="{{'global-payment.name-on-card'|translate}}*" [value]="cardName"
                    (appChange)="cardNameChange($event)"></app-input>
                </div>
              </div>
            </div>

            <div class="col-md-3 mt-3 mt-md-0">
              <div class="row pr-2">
                <div class="col-2 col-md-3 text-center">
                  <i class="far fa-credit-card"></i>
                </div>
                <div class="col-10 col-md-9 p-0">
                  <label for="number" class="font-13">{{'global-payment.card-number'|translate}}*</label>
                  <div style="height: 50px !important; margin-top: -10px !important" id="card-number"
                    class="get-payment-fields">
                    <div class="field-message" style="display: none"></div>
                  </div>
                </div>
              </div>
            </div>

            <!-- cvv and expiry date -->
            <div class="col-md-3 mt-3 mt-md-0">
              <div class="row pr-2">
                <div class="col-2 col-md-3 text-center">
                  <i class="far fa-calendar-alt"></i>
                </div>
                <div class="col-10 col-md-9 p-0">
                  <label for="expiration" class="font-13">{{'global-payment.expiration-date'|translate}}*</label>
                  <div style="height: 50px !important; margin-top: -10px !important" id="card-expiration"
                    class="get-payment-fields">
                    <div class="field-message" style="display: none"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 mt-3 mt-md-0">
              <div class="row">
                <div class="col-2 col-md-3 text-center">
                  <i class="far fa-credit-card"></i>
                </div>
                <div class="col-10 col-md-9 p-0 pr-2">
                  <label for="cvv" class="font-13">{{'global-payment.cvv'|translate}}*</label>
                  <div style="height: 50px !important; margin-top: -10px !important" id="card-cvv"
                    class="get-payment-fields">
                    <div class="field-message" style="display: none"></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- cvv and expiry -->
          </div>
          <!-- billing address -->
          <div class="row m-0">
            <div class="col-12 p-0">
              <strong>{{'global-payment.billing-details'|translate}}</strong>
            </div>

          </div>
          <div style="clear: both;"></div>
          <div class="row pt-md-3 mt-3 pt-2">
            <div class="col-md-3">
              <div class="row pr-2">
                <div class="col-2 col-md-3 text-center">
                  <i class="far fa-map-marker-alt"></i>
                </div>
                <div class="col-10 col-md-9 p-0">
                  <label class="mb-0 font-13" for="streetAddress">{{'global-payment.street-address'|translate}}*</label>
                  <app-input style="display: block" class="card-zip-field" id="streetAddress"
                    placeholder="{{'global-payment.street-address'|translate}}" [value]="billingAddress.street"
                    (appChange)="updateValueChange($event, 'street')"></app-input>
                </div>
              </div>
            </div>
            <div class="col-md-3 mt-3 mt-md-0">
              <div class="row pr-2">
                <div class="col-2 col-md-3 text-center">
                  <i class="far fa-paper-plane"></i>
                </div>
                <div class="col-10 col-md-9 p-0">
                  <label class="mb-0 font-13" for="city">{{'global-payment.city'|translate}}</label>
                  <app-input style="display: block" class="card-zip-field" id="city"
                    placeholder="{{'global-payment.city'|translate}}" [value]="billingAddress.city"
                    (appChange)="updateValueChange($event, 'city')"></app-input>
                </div>
              </div>
            </div>
            <div class="col-md-3 mt-3 mt-md-0">
              <div class="row pr-2">
                <div class="col-2 col-md-3 text-center">
                  <i class="far fa-location"></i>
                </div>
                <div class="col-10 col-md-9 p-0">
                  <label class="mb-0 font-13" for="state">{{'global-payment.state'|translate}}</label>
                  <app-input style="display: block" class="card-zip-field" id="state"
                    placeholder="{{'global-payment.state'|translate}}" [value]="billingAddress.state"
                    (appChange)="updateValueChange($event, 'state')"></app-input>
                </div>
              </div>
            </div>
            <div class="col-md-3 mt-3 mt-md-0">
              <div class="row pr-2">
                <div class="col-2 col-md-3 text-center">
                  <i class="far fa-credit-card"></i>
                </div>
                <div class="col-10 col-md-9 p-0">
                  <label class="mb-0 font-13" for="zip">{{'global-payment.zip-pin-code'|translate}}*</label>
                  <app-input style="display: block" class="card-zip-field" id="zip"
                    placeholder="{{'global-payment.zip-pin-code'|translate}}" [value]="billingAddress.zip"
                    (appChange)="updateValueChange($event, 'zip')"></app-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- privacy policy  -->
    <div class="ui-g-12 mt-2 privacy-policy payment-date">
      <div>
        <span class="font-11">
          <b>{{'global-payment.return-and-refund-policy'|translate}}</b>
          {{'global-payment.the-merchant-reserves-the-right-to-decline-any-request-for-refund-due-to-services-rendered'|translate}}
        </span>
      </div>
      <div class="address-fields">
        <span>{{ company?.name }}</span>
      </div>
      <!-- color gray-45, font-10 -->
      <div class="address-fields">
        <span> {{ company?.address?.addLine1 }}, </span>
        <span> {{ company?.address?.addLine2 }}, </span>
        <span>{{ company?.address?.city }}, {{ company?.address?.stateCode }}, </span>
        <span> {{ company?.address?.zip }} , </span>
        <span> {{ company?.address?.country }} </span>
      </div>
      <div class="address-fields">
        <span>{{'global-payment.phone'|translate}}: {{ company?.phone | mask : '(000) 000-0000' }} | </span>
        <span>{{'global-payment.email'|translate}}: {{ company?.email }} |</span>
        <span><a href="{{ redirect }}" target="_blank"> {{'global-payment.privacy-and-security-policy'|translate}}
          </a></span>
      </div>
    </div>
  </div>

  <!-- footer -->
  <!-- {{isProcessing}} -->
  <!-- *ngIf="!isProcessing" -->
  <div class="ui-g-12 p-zero dialog-footer flex-end-center">
    <div class="ui-g-8 p-1 text-right payment-add-footer">
      <button [disabled]="isSubmitting" id="payment-btn-cancel" class="btn btn-white btn-border pointer btn-submit mr-3"
        (click)="$event.stopPropagation(); closePaymentModal(false, {})">
        {{'cancel'|translate}}
      </button>

      <div class="container-form">
        <div *ngIf="isSubmitting" class="overlay-form flex-center-center">
          <button [disabled]="isSubmitting" id="payment-btn-save" [ngClass]="{'btn-style-french': currentLang === 'fr'}"
            class="btn btn-primary d-flex align-items-center w-auto">
            <span class="pr-1">{{'global-payment.pay-now'|translate}}</span>
            <i style="color: white" class="fal fa-spinner rotate"></i>
          </button>
        </div>
        <div class="content-form" id="submit" name="card-submit" style="width: 100px"></div>
      </div>
    </div>
  </div>
</div>